import React from "react";

import { AdministrationCard } from "@common/components/AdministrationCard/AdministrationCard";
import Button from "@common/components/Button/Button";
import { GridTable } from "@common/components/GridTable/GridTable";
import { useModal } from "@common/components/Modal/Modal";
import { Workspace } from "@common/models";
import { Customer, Invoice } from "@common/models/billing";
import { isAdmin } from "@common/models/Member.model";
import identifiers from "@common/util/identifiers.json";

import { ReceiptRow } from "./ReceiptRow";
import CustomizeBillingModalBody from "../ModalBody/CustomizeBillingModalBody";

interface ReceiptsCardProps {
  receipts: Invoice[];
  customer: Customer;
  selectedWorkspace?: Workspace;
}

export default function ReceiptsCard({ receipts, customer, selectedWorkspace }: ReceiptsCardProps): JSX.Element {
  const {
    Modal: CustomizeBillingModal,
    toggle: toggleCustomize,
    modalProps,
  } = useModal({ size: "narrow", hash: "#customize", allowOpen: isAdmin(selectedWorkspace?.role) });

  return (
    <AdministrationCard
      title="Receipts"
      subtitle="View and download all your previous receipts here."
      topLeftAccessory={
        <Button
          size="small"
          onClick={toggleCustomize}
          testId={identifiers["billing.button.customize"]}
        >
          Customize billing
        </Button>
      }
      testId={identifiers["billing.header.receipts"]}
      isEmpty={!receipts || !Boolean(receipts.length)}
    >
      <GridTable gridTemplateColumns="repeat(4, auto)">
        {receipts.map((receipt) => {
          return (
            <ReceiptRow
              key={receipt.id}
              receipt={receipt}
            />
          );
        })}
      </GridTable>

      <CustomizeBillingModalBody
        customer={customer}
        toggle={toggleCustomize}
        Modal={CustomizeBillingModal}
        internalProps={modalProps}
      />
    </AdministrationCard>
  );
}
